import { useTrack } from '~/hooks/track';
import { getConfig } from '@sunbit-dev/common/services/config';
import { applyOnlineNetworkServiceInit } from '~/services/applyOnlineNetworkService';
import { useQueryParams } from '~/hooks/useQueryParams';

enum SetupState {
  Initial,
  InProgress,
  Done,
}

let setupState = SetupState.Initial;
export const ApplicationSessionSetup = ({ children }) => {
  const { token } = useQueryParams();
  const { track } = useTrack();

  if (setupState === SetupState.Initial) {
    setupState = SetupState.InProgress;

    const init = async () => {
      const configService = getConfig();

      applyOnlineNetworkServiceInit({ baseUrl: configService.getItem('apiUrl'), track, token: token as string });
      setupState = SetupState.Done;
    };

    // Using main suspense
    throw init();
  }

  if (setupState !== SetupState.Done) return null;

  return children;
};

// let isSetupIsDone = false;
// export const ApplicationSessionSetup = ({ children }) => {
//   const { track } = useTrack();
//   const { token } = useQueryParams()
//
//   if (!isSetupIsDone) {
//     const init = async () => {
//       const configService = getConfig();
//
//       applyOnlineNetworkServiceInit({ baseUrl: configService.getItem('apiUrl'), track, token: token as string });
//       isSetupIsDone = true;
//     };
//
//     // Using main suspense
//     throw init();
//   }
//
//   return children;
// };
